export default {
    modelValue: [String, Number, Array],
    value: [Boolean, String, Number],
    name: String,
    required: Boolean,
    disableNameParser: Boolean,
    field: String,
    hideFieldInput: Boolean,
    enableField: Boolean,
    ignoreFormData: Boolean,
    label: String,
    type: {
        type: String,
        default: 'text'
    },
    error: String,
    errorField: String,
    disableErrorMessage: Boolean,
    infoText: [String, Object],
    labelDisabled: Boolean,
    labelClass: [String, Object, Array],
    clearable: {
        type: Boolean,
        default: true
    },
    interactive: Boolean,
    placeholder: String,
    spellcheck: Boolean,
    disabled: [Boolean, Number],
    resizable: Boolean,
    autoResize: Boolean,
    dropable: Boolean,
    explanation: String,

    inputClass: [String, Array, Object],
    inputGroupClass: [String, Array, Object],
    small: Boolean,

    // Select
    payload: [String, Array, Object],
    inline: Boolean,
    multiple: Boolean,
    disableSearch: Boolean,
    autocomplete: Boolean,
    params: Object,
    grid: [Boolean, Number, String],
    disableControls: Boolean,
    confirmable: Boolean,
    action: Array,
    placement: String,
    dependsOn: String,

    // Datepicker
    range: Boolean,
    rangeStart: [String, Object],
    rangeEnd: [String, Object],
    timePicker: Boolean,
    enableTemplates: Boolean,
    templates: Array,
    dateFormat: {
        type: String,
        default: 'yyyy-MM-dd'
    },
    timeFormat: {
        type: String,
        default: 'HH:mm'
    },

    class: [String, Object, Array],
    style: [String, Object],

    // Keys
    valueKey: {
        type: String,
        default: 'id'
    },
    titleKey: {
        type: String,
        default: 'title'
    },
    groupKey: {
        type: String,
        default: 'group_id',
    },
    groupValueKey: {
        type: String,
        default: 'id'
    },
    groupTitleKey: {
        type: String,
        default: 'title'
    },
    searchKey: {
        type: String,
        default: 'search'
    },
}